// tslint:disable:jsx-no-multiline-js (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../styling/rostelecom-radium';
import InternationalizedComponent from '../../../../../components/base/internationalized-component';
import './rostelecom-layout-root.less';
import rostelecomStylesStore, {
    IRostelecomStyleParamsStoreState
} from '../../styling/rostelecom-styles-store';
import HeadStyle from '../../../../head-style/head-style';
import windowSizeStore, {
    IWindowSizeStoreState
} from '../../../../../services/window-size/window-size-store';
import loginStoreState, { ILoginStoreState } from '../../../../../services/login/login-store';
import LoginPage from '../../pages/login/login-page';
import RestorePasswordPage from '../../pages/login/restore-password-page';
import ResetPasswordPage from '../../pages/login/reset-password-page';
import LoginLogo from '../../pages/login/elements/login-logo';
import LoginLoader from '../../pages/login/elements/login-loader';
import Color from 'color';
import { hot } from 'react-hot-loader/root';
import { AcceptTosDialog } from '../../../dit-pnp/pages/login/dialogs/accept-tos-dialog';
import {
    emailConfiramtionDialogId,
    EmailConfirmationDialog,
    IConfirmationEmailDialogData
} from '../../../dit-pnp/pages/login/dialogs/email-confirmation-dialog';
import { IRadiumExtStyles } from '../../../../base/radium-types';
import dialogsStore, { IStoredDialogState } from '../../../../../services/dialogs/dialogs-store';

export interface IRostelecomLayoutRootState {
    styleParams: IRostelecomStyleParamsStoreState;
    windowSize: IWindowSizeStoreState;
    loginStore: ILoginStoreState;
    confirmEmailDialog: IStoredDialogState<IConfirmationEmailDialogData>;
}

const topPlateHeight = 50;

@Radium
class RostelecomAuthRootComponent extends InternationalizedComponent<
    {},
    IRostelecomLayoutRootState
> {
    constructor(props: {}, options: {}) {
        super(props, options);
        this.stores = {
            confirmEmailDialog: dialogsStore.getDialogStore(emailConfiramtionDialogId),
            loginStore: loginStoreState,
            styleParams: rostelecomStylesStore,
            windowSize: windowSizeStore
        };
        this.initialize();
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    getHtmlStyle() {
        const styleParams = this.state.styleParams;
        return `
            @font-face {
                font-family: '{defaultFontFamily}';
                font-weight: normal;
                font-style: normal;
                src: {defaultFontFaceSrc};
            }
            body {
                box-sizing: border-box;
                margin: 0;
                padding: 0;
                font-size: 11pt;
                overflow-x: hidden;
                color: {defaultFontColor};
                font-family: {defaultFontFamilyWithFallback};
            }
            .top-plate {
                background-color: {baseMediumDarkColor};
                height: {topPlateHeight}px;
                line-height: 50px;
                text-align: left;
                box-sizing: border-box;
            }
            .header {
                font-size: 18px;
                line-height: 20px;
                margin: 0 0 20px;
                padding: 0;
                color: {headerColor};
            }
            #react-main-app {

            }`
            .replace('{defaultFontFamily}', styleParams.defaultFontFamily)
            .replace('{defaultFontFaceSrc}', styleParams.defaultFontFaceSrc)
            .replace('{defaultFontColor}', styleParams.defaultFontColor)
            .replace('{baseMediumDarkColor}', styleParams.baseMediumDarkColor)
            .replace(
                '{headerColor}',
                Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString()
            )
            .replace(
                '{defaultFontFamilyWithFallback}',
                "'" + styleParams.defaultFontFamily + "'," + styleParams.fallbackFontFamily
            )
            .replace('{topPlateHeight}', String(topPlateHeight));
    }

    public renderContent = ({
        confirmEmailDialog,
        styleParams,
        windowSize,
        loginStore
    }: {
        confirmEmailDialog: IStoredDialogState<IConfirmationEmailDialogData>;
        styleParams: IRostelecomStyleParamsStoreState,
        windowSize: IWindowSizeStoreState,
        loginStore: ILoginStoreState
    }) => {
        const isConfirmEmailDialogVisible = confirmEmailDialog && confirmEmailDialog.visible;
        const loading =
            !loginStore ||
            loginStore.authorizing ||
            loginStore.authorized ||
            loginStore.resettingPassword ||
            loginStore.restoringPassword;

        if (isConfirmEmailDialogVisible) {
            return (
                <EmailConfirmationDialog
                    confirmEmailDialog={confirmEmailDialog}
                    loginStore={loginStore}
                    styles={styleParams}
                />
            );
        }
        if (loginStore.page === 'reset-password') {
            return (
                <React.Fragment>
                    <h1 className="header">{this.i18n('js.auth.pages.login.title')}</h1>
                    <div key="formOuter" style={{ position: 'relative' }}>
                        <ResetPasswordPage {...{ styleParams, windowSize, loginStore }} />
                    </div>
                    <LoginLoader {...{ styleParams, windowSize, visible: loading }} />
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <h1 className="header">{this.i18n('js.auth.pages.login.title')}</h1>
                <div key="formOuter" style={{ position: 'relative' }}>
                    <RestorePasswordPage {...{ styleParams, windowSize, loginStore }} />
                    <AcceptTosDialog
                        loginStore={this.state.loginStore}
                        styles={this.state.styleParams}
                    />
                    <LoginPage {...{ styleParams, windowSize, loginStore }} />
                </div>
                <LoginLoader {...{ styleParams, windowSize, visible: loading }} />
            </React.Fragment>
        );
    }

    public render(): JSX.Element {
        const { styleParams, windowSize } = this.state;
        const marginTop = Math.max(0, (this.state.windowSize.height - 280) / 3.33); // center vertically
        let topPlateStyle = {};
        /*************************************
*************************
******************************************
**********
*********************************/

        return (
            <div className="row">
                <HeadStyle styleText={this.getHtmlStyle()} />
                <div
                    className="col"
                    style={{
                        width: Radium.getTotalWidth(),
                        position: 'relative',
                        textAlign: 'center'
                    }}
                >
                    <div className="top-plate" style={topPlateStyle}>
                        <LoginLogo
                            {...{ styleParams, windowSize }}
                            wrapperHeight={topPlateHeight}
                        />
                    </div>
                    <div
                        key="authOuter"
                        style={
                            {
                                widthFix: 256,
                                marginTop,
                                display: 'inline-block'
                            } as IRadiumExtStyles
                        }
                    >
                        {this.renderContent(this.state)}
                    </div>

                </div>
            </div>
        );
    }
}

export const RostelecomAuthRoot = hot(RostelecomAuthRootComponent);
